/* eslint-disable @typescript-eslint/no-unused-vars */
import { defineStore } from "pinia";
export const useKooiNavigation = defineStore("kooiNavigation", {
    state: () => ({
        activeTab: 1,
    }),
    getters: {
        getActiveTab: (state) => {
            return null;
        },
        tabs: (state) => {
            return null;
        },
    },
    actions: {
        setSubkey(key) {
        },
        setTabActive(tab) {

        },
    },
});
